import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Button } from '../../components/ui/Button';
import { getProgramById } from '../../data/programs';
import { Zap, Brain, Dumbbell, Users } from 'lucide-react';
export function TeenAdultClassesPage() {
  const program = getProgramById('teen-adult-classes');
  if (!program) {
    return null;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-1172">
      <Header data-id="element-1173" />

      <main className="pt-20" data-id="element-1174">
        {/* Hero Section with Background Image */}
        <section className="relative py-24 md:py-32 overflow-hidden" data-id="element-1175">
          <div className="absolute inset-0 z-0" data-id="element-1176">
            <img src={program.image} alt={program.name} className="w-full h-full object-cover" data-id="element-1177" />
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/75" data-id="element-1178"></div>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1179">
            <div className="max-w-3xl" data-id="element-1180">
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-1181">
                {program.name}
              </h1>
              <p className="text-xl text-slate-200 mb-8 leading-relaxed" data-id="element-1182">
                Transform your body, sharpen your mind, and master practical
                self-defense skills in a supportive, results-driven environment.
              </p>
              <Button variant="primary" size="lg" className="text-lg" data-id="element-1183">
                Start Your Training Today
              </Button>
            </div>
          </div>
        </section>

        {/* Benefits Grid */}
        <section className="py-16 bg-slate-50" data-id="element-1184">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1185">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1186">
              <div className="text-center" data-id="element-1187">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] rounded-full mb-4" data-id="element-1188">
                  <Zap className="w-8 h-8 text-white" data-id="element-1189" />
                </div>
                <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-1190">
                  Real Self-Defense
                </h3>
                <p className="text-slate-600" data-id="element-1191">
                  Learn practical techniques that work in real-world situations
                </p>
              </div>

              <div className="text-center" data-id="element-1192">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] rounded-full mb-4" data-id="element-1193">
                  <Dumbbell className="w-8 h-8 text-white" data-id="element-1194" />
                </div>
                <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-1195">
                  Total Body Fitness
                </h3>
                <p className="text-slate-600" data-id="element-1196">
                  Get in the best shape of your life while learning martial arts
                </p>
              </div>

              <div className="text-center" data-id="element-1197">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] rounded-full mb-4" data-id="element-1198">
                  <Brain className="w-8 h-8 text-white" data-id="element-1199" />
                </div>
                <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-1200">
                  Mental Clarity
                </h3>
                <p className="text-slate-600" data-id="element-1201">
                  Reduce stress and improve focus through disciplined practice
                </p>
              </div>

              <div className="text-center" data-id="element-1202">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] rounded-full mb-4" data-id="element-1203">
                  <Users className="w-8 h-8 text-white" data-id="element-1204" />
                </div>
                <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-1205">
                  Supportive Community
                </h3>
                <p className="text-slate-600" data-id="element-1206">
                  Train alongside motivated individuals who push you to excel
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16 bg-white" data-id="element-1207">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1208">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-6" data-id="element-1209">
              More Than Just a Workout—It's a Lifestyle Transformation
            </h2>

            <div className="prose prose-lg max-w-none text-slate-700 space-y-6" data-id="element-1210">
              <p data-id="element-1211">
                Let's be honest: most fitness routines get boring fast. You show
                up, go through the motions, and leave feeling like you're just
                checking a box. Our Teen & Adult Classes are different. Every
                session challenges you physically and mentally, keeping you
                engaged while delivering real, measurable results.
              </p>

              <p data-id="element-1212">
                Whether you're a teenager looking to build confidence and
                discipline or an adult seeking a fresh approach to fitness and
                self-defense, our program meets you where you are. No prior
                martial arts experience? No problem. Our structured curriculum
                takes you from fundamental techniques to advanced skills at your
                own pace, with instructors who provide personalized guidance
                every step of the way.
              </p>

              <p data-id="element-1213">
                The physical benefits speak for themselves. You'll build
                functional strength, improve cardiovascular endurance, increase
                flexibility, and develop explosive power. But the mental gains
                are just as impressive. Training martial arts requires focus,
                discipline, and strategic thinking—skills that translate
                directly to your personal and professional life. Students
                consistently report better stress management, improved
                confidence in challenging situations, and a clearer sense of
                purpose.
              </p>

              <p data-id="element-1214">
                Self-defense isn't just about physical techniques—it's about
                awareness, confidence, and the ability to stay calm under
                pressure. You'll learn practical skills that could protect you
                or someone you care about, while developing the mental fortitude
                to handle difficult situations with composure. That peace of
                mind is invaluable.
              </p>

              <p data-id="element-1215">
                What sets our program apart is the community. You're not just
                another member—you're part of a team. You'll train alongside
                people who share your commitment to growth, who celebrate your
                victories, and who push you to be better. The friendships and
                connections formed on the mat often become some of the most
                meaningful relationships in our students' lives.
              </p>

              <p data-id="element-1216">
                Our classes are designed to fit your schedule, with multiple
                sessions throughout the week at convenient times. Whether you're
                juggling school, work, or family commitments, we make it easy to
                stay consistent. And consistency is where the magic
                happens—where you see your body transform, your skills sharpen,
                and your confidence soar.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-[#dc2626] to-[#b91c1c] text-white" data-id="element-1217">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1218">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1219">
              Ready to Unlock Your Full Potential?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-1220">
              Experience the difference for yourself. Try 2 weeks of training
              completely free—no strings attached. Discover why hundreds of
              teens and adults choose Che Ko for their martial arts journey.
            </p>
            <Button variant="secondary" size="lg" className="text-lg shadow-xl" data-id="element-1221">
              Get Started with 2 Free Weeks
            </Button>
            <p className="text-sm text-white/80 mt-4" data-id="element-1222">
              All fitness levels welcome • Flexible schedule • Expert
              instruction
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-1223" />
    </div>;
}